export const providersQueryKey = (companyKey, initial = 0, take = 100) =>
  ['providers', companyKey, initial, take]

export const invoicesQueryKey = (companyKey, initial = 0, take = 500) =>
  ['invoices', companyKey, initial, take]

export const withholdingsQueryKey = (companyKey, dateFrom, dateTo, initial = 0, take = 100) =>
  ['withholdings', companyKey, dateFrom, dateTo, initial, take]
